import { Check } from "lucide-react";
import { motion } from "framer-motion";
import Seo, { buildBreadcrumbLd } from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import PageHero from "../components/PageHero";
import Reveal, { StaggerGroup, itemVariants } from "../components/Reveal";
import ContactForm from "../components/ContactForm";

const crumbs = [
  { label: "Startseite", to: "/" },
  { label: "Geschäftskunden", to: "/geschaeftskunden" },
];

const leistungen = [
  "Büro- und Praxisauflösungen",
  "Lager- und Hallenräumungen",
  "Werkstatträumungen",
  "Räumungen für Hausverwaltungen",
  "Räumungen für gesetzliche Betreuer",
  "Räumungen für Kanzleien",
  "Räumungen für soziale Einrichtungen",
  "Transport und Möbelmontage",
  "Demontage",
  "Einlagerung",
  "Mehrstufige Projektplanung",
  "Fachgerechte Entsorgung",
];

export default function Geschaeftskunden() {
  return (
    <div data-testid="page-geschaeftskunden">
      <Seo
        path="/geschaeftskunden"
        title="Geschäftskunden | Büro- & Gewerberäumung Ulm, Neu-Ulm, Illertissen | Rümpeltaxi"
        description="Räumung und Entsorgung für Unternehmen, Hausverwaltungen und Institutionen in Ulm, Neu-Ulm und der Region: Büro-, Praxis- und Lagerräumung mit planbaren Terminen. Rümpeltaxi aus Altenstadt."
        jsonLd={buildBreadcrumbLd(crumbs)}
      />
      <Breadcrumbs items={crumbs} />
      <PageHero
        kicker="Für Geschäftskunden"
        title="Planbare Lösungen für Unternehmen und Institutionen"
        lead="Wir übernehmen umfangreiche Räumungs-, Transport- und Entsorgungsprojekte für Unternehmen, Hausverwaltungen, Kanzleien, gesetzliche Betreuer und soziale Einrichtungen – mit klarer, abgestimmter Terminplanung."
      />

      <section className="bg-white py-16 md:py-24">
        <div className="container-page">
          <Reveal>
            <h2 className="font-heading text-2xl font-bold text-anthracite md:text-3xl">Mögliche Leistungen</h2>
          </Reveal>
          <StaggerGroup className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {leistungen.map((l) => (
              <motion.div
                key={l}
                variants={itemVariants}
                className="flex items-start gap-3 rounded-sm border border-light-gray bg-light-gray p-4"
              >
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-yellow text-brand-black">
                  <Check className="h-4 w-4" />
                </span>
                <span className="text-base text-anthracite">{l}</span>
              </motion.div>
            ))}
          </StaggerGroup>
        </div>
      </section>

      <section className="bg-light-gray py-16 md:py-24" data-testid="business-form-section">
        <div className="container-page grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <Reveal>
            <span className="kicker">Anfrage</span>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-anthracite md:text-4xl">
              Geschäftskunden-Anfrage
            </h2>
            <p className="mt-6 text-base leading-relaxed text-mid-gray">
              Schildern Sie uns Ihr Projekt. Für umfangreiche oder mehrstufige Vorhaben vereinbaren
              wir gerne eine Objektbegehung und erstellen ein abgestimmtes Angebot.
            </p>
          </Reveal>
          <Reveal delay={1}>
            <div className="rounded-sm border border-white bg-white p-6 md:p-8">
              <ContactForm variant="business" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
